import { useState, useEffect } from 'react';
import axios, { API, authHeaders, errText } from '../api';
import Layout from './Layout';
import { ui } from '../ui';
import { colors } from '../theme';

const TOGGLES = [
  {
    key: 'payments_enabled',
    label: 'Покупка искр',
    hint: 'Пользователи могут покупать искры за деньги',
    offQuestion: 'Отключить покупку искр для всех пользователей? При попытке купить они увидят сообщение, что покупка временно недоступна.',
    onQuestion: 'Снова разрешить покупку искр пользователям?',
  },
  {
    key: 'sms_enabled',
    label: 'Дозвон с кодом',
    hint: 'Коды регистрации и входа через звонок (GreenSMS flash-call)',
    offQuestion: 'Отключить дозвон с кодом? Регистрация и вход по коду станут недоступны для всех пользователей, пока не включите обратно.',
    onQuestion: 'Снова включить дозвон с кодом?',
  },
  {
    key: 'email_enabled',
    label: 'Отправка писем',
    hint: 'Резервная доставка кода на почту ("Не поступает звонок?")',
    offQuestion: 'Отключить отправку кодов на почту? Резервный канал "Не поступает звонок?" станет недоступен, пока не включите обратно.',
    onQuestion: 'Снова включить отправку кодов на почту?',
  },
];

function Toggle({ checked, onChange, disabled }) {
  return (
    <div
      onClick={disabled ? undefined : onChange}
      style={{
        width: 44, height: 24, borderRadius: 12, padding: 2, cursor: disabled ? 'default' : 'pointer',
        background: checked ? colors.good : colors.border, transition: 'background 0.15s', opacity: disabled ? 0.5 : 1,
        display: 'flex', justifyContent: checked ? 'flex-end' : 'flex-start',
      }}
    >
      <div style={{ width: 20, height: 20, borderRadius: '50%', background: '#fff' }} />
    </div>
  );
}

export default function Settings() {
  const [settings, setSettings] = useState(null);
  const [savingKey, setSavingKey] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API}/admin/settings`, { headers: authHeaders() }).then(r => setSettings(r.data));
  }, []);

  const toggle = async (item) => {
    const next = !settings[item.key];
    if (!window.confirm(next ? item.onQuestion : item.offQuestion)) return;
    setError('');
    setSavingKey(item.key);
    try {
      const payload = { ...settings, [item.key]: next };
      const r = await axios.patch(`${API}/admin/settings`, payload, { headers: authHeaders() });
      setSettings(r.data);
    } catch (e) {
      setError(errText(e, 'Не удалось изменить настройку'));
    }
    setSavingKey(null);
  };

  return (
    <Layout>
      <h1 style={ui.title}>Настройки</h1>
      {error && <div style={ui.error}>{error}</div>}
      {!settings ? (
        <div style={ui.empty}>Загрузка…</div>
      ) : (
        <div style={ui.card}>
          {TOGGLES.map((item, i) => (
            <div
              key={item.key}
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '14px 0', borderBottom: i < TOGGLES.length - 1 ? `1px solid ${colors.border}` : 'none',
              }}
            >
              <div>
                <div style={{ fontWeight: 600, color: colors.text, fontSize: 14 }}>{item.label}</div>
                <div style={{ fontSize: 12, color: colors.textMuted, marginTop: 2 }}>{item.hint}</div>
              </div>
              <Toggle checked={settings[item.key]} onChange={() => toggle(item)} disabled={savingKey === item.key} />
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
